import React, { Component } from "react";
import { Row, Col, Container, Card, Form, FormGroup } from "react-bootstrap";
import moment from "moment";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import { components } from 'react-select';
import Button from "react-bootstrap/Button";
import Select from "react-select";
import compose from "lodash.flowright";
import { Spinner } from "react-bootstrap";
import SelectBoxWithDisabledOption from '../selectdropdown/SelectBoxWithDisabledOption';
import { isBrowser } from "react-device-detect";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import DateBlock from "../home/DateBlock"
import PreloaderTwo from '../preloader/PreloaderTwo';
import DataTableWithOutSearch from "../datatables/DataTableWithOutSearch";
import { getExamTypeId, getExamTypeLabel, onExamTypeChange } from "../../../utils/examScope";
import TopStudentsChart from "./StudentChart";
import ExamReportForOverall from "./ExamReportForOverall";
import BatchReportsCollege from "./BatchReportsCollege";
import CardLessDataTableWithSearch from "../datatables/CardLessDataTableWithSearch";
import MultiSelectFilters from "../reusableDropDownComponents/MultiSelectDropdown";
import MultiSelect from "react-multi-select-component";
import { filterStudentsData } from "../reusableDropDownComponents/filterHelper";
import { buildFilterConfig } from "../reusableDropDownComponents/FilterConfig";
import useStudentFilters from "../reusableDropDownComponents/CutormHookFilter";
import { stateWiseExamColumns, districtWiseExamColumns, cityWiseExamColumns, branchWiseExamColumns, sectionWiseExamColumns } from "./TableCoumns";
import { withApollo } from "react-apollo";

const FETCH_GLOBALS = gql`
  query($institution_id: Int!) {
    globals(institution_id: $institution_id) {
      b_e_c_s_data {
        section_id
        class_id
        branch_id
        exam_id
        state_id
        city_id
        district_id
      }
      educationalClasses {
        id
        class
      }
      globalPackages {
        id
        package_name
        exams_covered
      }
      globalCategories {
        id
        category_name
        package_id
      }
      classes {
        id
        class
      }
      exams {
        id
        exam
        exam_subjects{
                subject_id
              }
      }
      globalBranches {
        id
        branch_name
        state_id
        city_id
        district_id
      }
      globalSections {
        id
        section_name
        branch_id
        category_id
        package_id
      }
      offlineExamSubjects{
        id
        subject
      }
      offlineFeeTypes{
        id
        fee_type
      }
         states {
      state_id
      state_name
    }
    districts {
      id
      district_name
      state_id
    }
    cities {
      id
      district_id
      region_id
      city_name
      timestamp
    }
    }
  }
`;
const FETCH_OVERALL_EXAMS_COUNTS = gql`
query (
  $institution_id: Int!,
  $exam_type: Int,
  $days: Int,
  $state_ids: [Int],
  $district_ids: [Int],
  $city_ids: [Int],
  $branch_ids: [Int],
  $section_ids: [Int],
    $class_ids: [Int]

) {
  getCountsForCollegeOverallExams(
    institution_id: $institution_id,
    exam_type: $exam_type,
    days: $days,
    state_ids: $state_ids,
    district_ids: $district_ids,
    city_ids: $city_ids,
    branch_ids: $branch_ids,
    section_ids: $section_ids,
     class_ids: $class_ids

  ) {
    totalExams
    totalStudents
    avgScore
    bestScore
    lessScore
  }
}
`;
const FETCH_STATE_WISE_DATA = gql`
query ( $institution_id: Int!,
  $exam_type: [Int],
  $state_ids: [Int],
  $class_ids: [Int]) {
  getStateWiseExamStatsCollegeOverall(
    institution_id: $institution_id,
    exam_type: $exam_type,
    state_ids: $state_ids,
    class_ids: $class_ids
  ) {
     state_id
  state_name

  exam_paper_id
  exam_name

  state_students
  state_avg
  state_max
  state_min
  }
  } 
`;


const FETCH_SECTION = gql`
query ($institution_id: Int!, $branch_id: Int!) {
  getSectionNames(institution_id: $institution_id, branch_id: $branch_id) {
    id
    section_name
  }
} 
`

const FETCH_EXAMS = gql`
query($institution_id: Int!){
  getDashBoardExams(institution_id : $institution_id){
    quiz_exams{
      id
      exam_name
      exam_type
      class_id
      start_time

    }
    full_exams{
      id
      exam_mode
      exam_name
      exam_type
      class_id 
      start_time
      end_time
      section{
        id
        section_name
        branch_id
        exam_id
      }
    }
  }
}
`;

const levelOptions = [
    { value: 1, label: "State" },
    { value: 2, label: "District" },
    { value: 3, label: "City" },
    { value: 4, label: "Branch" },
    { value: 5, label: "Section" },
];

class OverallReportsCollege extends Component {
    constructor(props) {
        super(props);
        this.reportRef = React.createRef();
        // Seed the exam-type from the GLOBAL header selection when one is set,
        // so the header selector drives this page. Falls back to the page's
        // historic default (JEE / 1) when the header is on "All Exams".
        const _globalExamTypeId = getExamTypeId();
        this.state = {
            exam_typeValue: _globalExamTypeId != null
                ? { value: _globalExamTypeId, label: getExamTypeLabel() }
                : { value: 1, label: "JEE" },
            exam_type: _globalExamTypeId != null ? _globalExamTypeId : 1,
            examTypeOptions: [],
            toggled: Cookies.get("toggle") || "wrapper",
            tableHeaderData: {
                Title: 'Exam wise data'
            },
            startDateCalender: moment(new Date()).subtract(1, "month").startOf('day').unix(),
            endDateCalender: moment(new Date()).startOf('day').unix(),
            // Multi-select filter state
            levelSelectedValue: [{ value: 1, label: "State" }],
            statesSelectedValue: [],
            selectedDistrictsValues: [],
            selectedCityValue: [],
            branchSelectedvalue: [],
            sectionSelectedvalue: [],
            examSelectedvalue: this.props.globals.globals?.exams?.length > 0 ? this.props.globals.globals.exams.map(e => ({ value: e.id, label: e.exam })) : null,      // Added for exam filter
            classSelectedvalue: [],      // Added for class filter

            // Options for dropdowns
            getLevelArr: levelOptions,
            getStateArr: [],
            getDistricts: [],
            getCities: [],
            getBranchArr: [],
            getSectionArr: [],
            getExamArr: [],              // Added for exam options
            getClassArr: [],             // Added for class options
            districtWiseExamStats: [],
            isDistrictLoading: false,
            isCityLoading: false,
            cityWiseExamStats: [],
            isBranchLoading: false,
            branchWiseExamStats: [],
            isSectionLoading: false,
            sectionWiseExamStats: [],
            isStateLoading: false,
            stateWiseExamStats: [],
            stateWiseResultReceived: false,
            renderedLevel: 1,
            // Other state
            dateFilter: "All",
            showFilter: false,
            showReportSection: false,
            isReportLoading: false,
            dateFilterOptions: [
                { value: "All", label: "All" },
                { value: 1, label: "1 Day" },
                { value: 7, label: "7 Days" },
                { value: 15, label: "15 Days" },
                { value: 30, label: "30 Days" },
                { value: 60, label: "60 Days" },
                { value: 90, label: "90 Days" }
            ],

        };
    }

    handleExamClick = (row) => {
        this.setState({
            isReportLoading: true,   // ✅ start loader
            showReportSection: true,
            exam_id: row.exam_paper_id,
            exam_name: row.exam_name,
            exam_type: this.state.exam_type,
            exam_typeValue: this.state.exam_typeValue,
            examsglobals: this.props.globals.globals.exams,
        }, () => {
            if (this.reportRef?.current) {
                this.reportRef.current.scrollIntoView({ behavior: "smooth" });
            }
        });
    };





    tableUserData(data) {
        if (!data) return [];

        return data.map((item, index) => ({
            id: item.id,
            slno: index + 1,
            exam_name: item.exam_name,
            exam_attempts: item.exam_attempts || 0,
            avg_marks: item.avg_marks ? parseFloat(item.avg_marks).toFixed(2) : 0,
            avg_accuracy: item.avg_accuracy ? parseFloat(item.avg_accuracy).toFixed(2) : 0,
            best_score: item.best_score || 0
        }));
    }

    defaultSorted = [
        {
            dataField: "slno",
            order: "asc"
        }
    ];

    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        const next =
            toggled === "wrapper"
                ? "wrapper sidebar-enable"
                : "wrapper";

        this.setState({ toggled: next });
        Cookies.set("toggle", next);
    };

    handleTabChange = (key) => {

        if (this.props.getCountsForCollegeOverallExams && this.props.getCountsForCollegeOverallExams.refetch) {
            this.props.getCountsForCollegeOverallExams.refetch({
                institution_id: parseInt(Cookies.get("institutionid")),
                exam_type: this.state.exam_type,

                exam_paper_id: 0

            });
        }
    };
    componentDidMount() {
        this.initializeFilterOptions();
        // React to the GLOBAL header exam-type selector: mirror the choice into
        // this page's exam_type and let the existing refetch path pick it up.
        this._offExamType = onExamTypeChange(() => {
            const id = getExamTypeId();
            if (id == null) return; // "All Exams" → keep page's current selection
            this.setState(
                { exam_type: id, exam_typeValue: { value: id, label: getExamTypeLabel() } },
                () => {
                    const q = this.props.getCountsForCollegeOverallExams;
                    if (q && q.refetch) {
                        q.refetch({
                            institution_id: parseInt(Cookies.get("institutionid")),
                            exam_type: id,
                        });
                    }
                },
            );
        });
    }
    componentWillUnmount() {
        if (this._offExamType) this._offExamType();
    }
    initializeFilterOptions() {
        const { globals } = this.props;

        if (!globals?.globals) {
            console.log("Globals data not available yet");
            return;
        }

        const globalsData = globals.globals;

        // Get states from globals
        const stateOptions = globalsData.states?.map(state => ({
            value: parseInt(state.state_id),
            label: state.state_name
        })) || [];

        // Get districts from globals
        const districtOptions = globalsData.districts?.map(district => ({
            value: district.id,
            label: district.district_name
        })) || [];

        // Get cities from globals
        const cityOptions = globalsData.cities?.map(city => ({
            value: parseInt(city.id),
            label: city.city_name
        })) || [];

        // Get branches from globals
        const branchOptions = globalsData.globalBranches?.map(branch => ({
            value: parseInt(branch.id),
            label: branch.branch_name
        })) || [];

        // Get sections from globals
        const sectionOptions = globalsData.globalSections?.map(section => ({
            value: parseInt(section.id),
            label: section.section_name
        })) || [];

        // Get exams from globals
        const examOptions = globalsData.exams?.map(exam => ({
            value: parseInt(exam.id),
            label: exam.exam
        })) || [];

        // Get classes from globals
        const classOptions = globalsData.classes?.map(cls => ({
            value: cls.id,
            label: cls.class
        })) || [];

        console.log("Initialized filter options:", {
            stateOptions,
            districtOptions,
            cityOptions,
            branchOptions,
            sectionOptions,
            examOptions,
            classOptions
        });

        this.setState({
            getStateArr: stateOptions,
            getDistricts: districtOptions,
            getCities: cityOptions,
            getBranchArr: branchOptions,
            getSectionArr: sectionOptions,
            getExamArr: examOptions,
            getClassArr: classOptions,
        });
    }

    componentDidUpdate(prevProps) {
        // Initialize filters when globals data loads
        if (
            !this.props.globals.loading &&
            this.props.globals.globals &&
            prevProps.globals.loading
        ) {
            this.initializeFilterOptions();
        }

        // Your existing exam type options logic
        if (
            !this.props.globals.loading &&
            this.props.globals.globals?.exams &&
            prevProps.globals.globals?.exams !== this.props.globals.globals?.exams
        ) {
            const examTypeArr = this.props.globals.globals.exams.map(item => ({
                value: Number(item.id),
                label: item.exam
            }));

            const defaultExam = examTypeArr.find(e => e.value === 2);

            this.setState({
                examTypeOptions: examTypeArr,
                exam_typeValue: defaultExam || examTypeArr[0],
                exam_type: defaultExam?.value || 1,
                // Populate the exam filter once globals arrive (constructor sees null on a cold cache).
                examSelectedvalue: this.state.examSelectedvalue
                    || (this.props.globals.globals.exams.length > 0
                        ? this.props.globals.globals.exams.map(e => ({ value: e.id, label: e.exam }))
                        : null)
            });
        }
    }

    checkAndInitializeFilters() {
        // Small delay to ensure data is available
        setTimeout(() => {
            this.initializeFilterOptions();
        }, 100);
    }

    selecthandleInputChange = (name, value, option) => {

        const examType = parseInt(value); // convert string → number

        this.setState({
            exam_typeValue: option,
            exam_type: examType
        }
            // , () => {

            //     console.log("Selected exam_type:", this.state.exam_type);

            //     this.props.getExams.refetch({
            //         institution_id: parseInt(Cookies.get("institutionid")),
            //         exam_type: examType
            //     });

            //     this.props.getExamsData.refetch({
            //         institution_id: parseInt(Cookies.get("institutionid")),
            //         exam_type: examType
            //     });

            //     this.props.getTopStudents.refetch({
            //         institution_id: parseInt(Cookies.get("institutionid")),
            //         exam_type: examType
            //     });

            // }
        );
    };
    setReportLoading = (value) => {
        this.setState({ isReportLoading: value });
    };

    handleLocationChange = (name, option) => {
        console.log(name, option, "option")
        if (name === "state") {
            this.setState({
                stateValue: option,
                districtOptions: option.districts || [],
                districtValue: null,
                cityValue: null,
                branchValue: null,
                sectionValue: null,
                cityOptions: [],
                branchOptions: [],
                sectionOptions: []
            });


        }

        if (name === "district") {
            this.setState({
                districtValue: option,
                cityOptions: option.cities || [],
                cityValue: null,
                branchValue: null,
                sectionValue: null,
                branchOptions: [],
                sectionOptions: []
            });


        }

        if (name === "city") {
            this.setState({
                cityValue: option,
                branchOptions: option.branches || [],
                branchValue: null,
                sectionValue: null,
                sectionOptions: []
            });



        }

        if (name === "branch") {
            this.setState({
                branchValue: option,
                sectionOptions: option.sections || [],
                sectionValue: null
            });


        }

        if (name === "section") {
            this.setState({ sectionValue: option });
        }
        if (name === "exam_type") {

            this.setState({
                exam_typeValue: option,
                exam_type: option.value
            })
            // this.props.getExamScheduleSubTypeQuestions.refetch({
            //     institution_id: parseInt(Cookies.get("institutionid")),
            //     type: option.value
            // });
        }

    };

    handleDateFilterChange = (option) => {

        this.setState(
            {
                dateFilter: option.value
            }
        );
    };

    handleFilter = async () => {
        // Extract IDs from selected values
        console.log(this.state.examSelectedvalue, "selfiuweilfyweiyiywe")
        const examIds = this.state.examSelectedvalue?.length > 0 ? this.state.examSelectedvalue.map(e => e.value) : null;
        const classIds = this.state.classSelectedvalue?.length > 0 ? this.state.classSelectedvalue.map(c => c.value) : null;

        const selectedLevel = this.state.levelSelectedValue?.[0]?.value || 1;

        console.log("Filtering with:", {
            selectedLevel,
            examIds,
            classIds,
            exam_type: this.state.exam_type,
            dateFilter: this.state.dateFilter
        });

        // Clear previous stats
        this.setState({
            sectionWiseExamStats: [],
            branchWiseExamStats: [],
            cityWiseExamStats: [],
            districtWiseExamStats: [],
            stateWiseExamStats: [],
        });

        if (selectedLevel === 5) { // Section
            this.setState({ isSectionLoading: true })
            const res = await this.props.client.query({
                query: gql`
query ( $institution_id: Int!,  $exam_type: [Int],  $section_ids: [Int], class_ids: [Int]) {
  getSectionwiseExamStats(
    institution_id: $institution_id,
    exam_type: $exam_type,
    section_ids: $section_ids,
    class_ids: $class_ids
  ) {
      state_id
  state_name

  district_id
  district_name
  city_id
city_name
branch_id
branch_name
section_id
section_name

  section_students
  section_avg
  section_max
  section_min

  branch_students
  branch_avg
  branch_max
  branch_min

  city_students
  city_avg
  city_max
  city_min
  exam_paper_id
  exam_name

  district_students
  district_avg
  district_max
  district_min

  state_students
  state_avg
  state_max
  state_min
}
}`,
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid")),
                    exam_type: this.state.examSelectedvalue?.length > 0 ? parseInt(this.state.examSelectedvalue[0].value) : null,
                    from_date: this.state.startDateCalender,
                    to_date: this.state.endDateCalender,
                    section_ids: this.props.globals.globals.globalSections.length > 0 ? this.props.globals.globals.globalSections.map(item => Number(item.id)) : null,
                    class_ids: this.state.classSelectedvalue?.length > 0 ? this.state.classSelectedvalue.map(c => c.value) : null,
                }
            });
            this.setState({
                sectionWiseExamStats: res.data.getSectionwiseExamStats,
                isSectionLoading: false,
                renderedLevel: 5,
                stateWiseExamStats: [],
                districtWiseExamStats: [],
                branchWiseExamStats: [],
                cityWiseExamStats: [],
            });
        } else if (selectedLevel === 4) { // Branch
            this.setState({ isBranchLoading: true })
            const res = await this.props.client.query({
                query: gql`
query ( $institution_id: Int!,  $exam_type: [Int],  $branch_ids: [Int], class_ids: [Int]) {
  getBranchWiseExamStats(
    institution_id: $institution_id,
    exam_type: $exam_type,
    branch_ids: $branch_ids,
    class_ids: $class_ids
  ) {
      state_id
  state_name

  district_id
  district_name
  city_id
city_name
branch_id
branch_name

branch_students
branch_avg
branch_max
branch_min

city_students
city_avg
city_max
city_min
  exam_paper_id
  exam_name

  district_students
  district_avg
  district_max
  district_min

  state_students
  state_avg
  state_max
  state_min
  }
  } 
`,
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid")),
                    exam_type: this.state.examSelectedvalue?.length > 0 ? parseInt(this.state.examSelectedvalue[0].value) : null,
                    from_date: this.state.startDateCalender,
                    to_date: this.state.endDateCalender,
                    branch_ids: this.props.globals.globals.globalBranches.length > 0 ? this.props.globals.globals.globalBranches.map(item => Number(item.id)) : null,
                    class_ids: this.state.classSelectedvalue?.length > 0 ? this.state.classSelectedvalue.map(c => c.value) : null,
                },
            })
            this.setState({
                branchWiseExamStats: res.data.getBranchWiseExamStats,
                isBranchLoading: false,
                renderedLevel: 4,
                stateWiseExamStats: [],
                districtWiseExamStats: [],
                cityWiseExamStats: [],
                sectionWiseExamStats: [],
            })
        } else if (selectedLevel === 3) { // City
            this.setState({ isCityLoading: true });
            const res = await this.props.client.query({
                query: gql`
query ( $institution_id: Int!,  $exam_type: [Int],  $city_ids: [Int], class_ids: [Int]) {
  getCityWiseExamStats(
    institution_id: $institution_id,
    exam_type: $exam_type,
    city_ids: $city_ids,
    class_ids: $class_ids
  ) {
      state_id
  state_name

  district_id
  district_name
  city_id
city_name
city_students
city_avg
city_max
city_min
  exam_paper_id
  exam_name

  district_students
  district_avg
  district_max
  district_min

  state_students
  state_avg
  state_max
  state_min
  }
  } 
`,
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid")),
                    exam_type: this.state.examSelectedvalue?.length > 0 ? parseInt(this.state.examSelectedvalue[0].value) : null,
                    from_date: this.state.startDateCalender,
                    to_date: this.state.endDateCalender,
                    city_ids: this.props.globals.globals.cities.length > 0 ? this.props.globals.globals.cities.map(item => Number(item.id)) : null,
                    class_ids: this.state.classSelectedvalue?.length > 0 ? this.state.classSelectedvalue.map(c => c.value) : null,
                },
            });
            this.setState({
                cityWiseExamStats: res.data.getCityWiseExamStats,
                isCityLoading: false,
                renderedLevel: 3,
                stateWiseExamStats: [],
                districtWiseExamStats: [],
                branchWiseExamStats: [],
                sectionWiseExamStats: [],
            });
        } else if (selectedLevel === 2) { // District
            this.setState({ isDistrictLoading: true });
            const res = await this.props.client.query({
                query: gql`
query ( $institution_id: Int!,  $exam_type: [Int],  $district_ids: [Int], class_ids: [Int]) {
  getDistrictWiseExamStats(
    institution_id: $institution_id,
    exam_type: $exam_type,
    district_ids: $district_ids,
    class_ids: $class_ids,

  ) {
      state_id
  state_name

  district_id
  district_name

  exam_paper_id
  exam_name

  district_students
  district_avg
  district_max
  district_min

  state_students
  state_avg
  state_max
  state_min
  }
  } 
`,
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid")),
                    exam_type: this.state.examSelectedvalue?.length > 0 ? parseInt(this.state.examSelectedvalue[0].value) : null,
                    from_date: this.state.startDateCalender,
                    to_date: this.state.endDateCalender,
                    district_ids: this.props.globals.globals.districts.length > 0 ? this.props.globals.globals.districts.map(item => Number(item.id)) : null,
                    class_ids: this.state.classSelectedvalue?.length > 0 ? this.state.classSelectedvalue.map(c => c.value) : null,
                },
            });
            this.props.getCountsForCollegeOverallExams.refetch({
                institution_id: parseInt(Cookies.get("institutionid")),
                from_date: this.state.startDateCalender,
                to_date: this.state.endDateCalender,
                exam_type: this.state.examSelectedvalue?.length > 0 ? parseInt(this.state.examSelectedvalue[0].value) : null,
                days: null,
                state_ids: null,
                district_ids: this.props.globals.globals.districts.length > 0 ? this.props.globals.globals.districts.map(item => Number(item.id)) : null,
                city_ids: null,
                branch_ids: null,
                section_ids: null,
                class_ids: this.props.globals.globals.globalClasses.length > 0 ? this.props.globals.globals.globalClasses.map(item => Number(item.id)) : null,

            });
            this.setState({
                districtWiseExamStats: res.data.getDistrictWiseExamStats,
                isDistrictLoading: false,
                renderedLevel: 2,
                stateWiseExamStats: [],
                cityWiseExamStats: [],
                branchWiseExamStats: [],
                sectionWiseExamStats: [],
            });
        } else if (selectedLevel === 1) {
            try {
                this.setState({ isStateLoading: true });

                const res = await this.props.client.query({
                    query: FETCH_STATE_WISE_DATA,
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid")),
                        from_date: this.state.startDateCalender,
                        to_date: this.state.endDateCalender,
                        class_ids: this.state.classSelectedvalue?.length > 0 ? this.state.classSelectedvalue.map(c => c.value   ) : null,
                        exam_type:
                            this.state.examSelectedvalue?.length > 0
                                ? parseInt(this.state.examSelectedvalue[0].value)
                                : null,
                        state_ids:
                            this.props.globals.globals.states.length > 0
                                ? this.props.globals.globals.states.map((item) =>
                                    Number(item.state_id)
                                )
                                : null,
                    },
                    fetchPolicy: "no-cache", // optional but recommended
                });

                this.setState({
                    stateWiseExamStats:
                        res?.data?.getStateWiseExamStatsCollegeOverall || [],
                    isStateLoading: false,
                    stateWiseResultReceived: true,
                    renderedLevel: 1,

                    // reset lower levels
                    districtWiseExamStats: [],
                    cityWiseExamStats: [],
                    branchWiseExamStats: [],
                    sectionWiseExamStats: [],
                });
            } catch (error) {
                console.error("State Wise API Error:", error);
                this.setState({ isStateLoading: false });
            }
        }


        this.props.getCountsForCollegeOverallExams.refetch({
            institution_id: parseInt(Cookies.get("institutionid")),
            exam_type: this.state.examSelectedvalue?.length > 0 ? parseInt(this.state.examSelectedvalue[0].value) : null,
            days: null,
            state_ids: this.props.globals.globals.states.length > 0 ? this.props.globals.globals.states.map(item => Number(item.state_id)) : null,
            district_ids: null,
            city_ids: null,
            branch_ids: null,
            section_ids: null,
            from_date: this.state.startDateCalender,
            to_date: this.state.endDateCalender,
            class_ids: this.state.classSelectedvalue?.length > 0 ? this.state.classSelectedvalue.map(c => c.value) : null,
        });

    };

    handleReset = () => {
        const stateIds = this.state.statesSelectedValue.map(s => s.value);
        this.setState({
            statesSelectedValue: [],
            selectedDistrictsValues: [],
            selectedCityValue: [],
            branchSelectedvalue: [],
            sectionSelectedvalue: [],
            examSelectedvalue: [],
            classSelectedvalue: [],
            dateFilter: "All",
            stateWiseExamStats: [],
            districtWiseExamStats: [],
            cityWiseExamStats: [],
            branchWiseExamStats: [],
            showReportSection: false,
        });

        // Reset all filter options
        this.initializeFilterOptions();

        this.props.getStateWiseExamStatsCollegeOverall.refetch({
            institution_id: parseInt(Cookies.get("institutionid")),
            exam_type: this.state.exam_type,
            state_ids: stateIds.length > 0 ? stateIds : null,
        });
        this.props.getCountsForCollegeOverallExams.refetch({
            institution_id: parseInt(Cookies.get("institutionid")),
            exam_type: this.state.exam_type,
            days: null,
            state_ids: null,
            district_ids: null,
            city_ids: null,
            branch_ids: null,
            section_ids: null,
            exam_ids: null,
            class_ids: null,
        });
    };
    //



    handleMultipleSelectInputChange = (selectedValues, filterName) => {
        console.log(`Filter changed: ${filterName}`, selectedValues);

        if (filterName === "level") {
            const newValue = selectedValues.length > 0 ? [selectedValues[selectedValues.length - 1]] : [];
            this.setState({
                levelSelectedValue: newValue,

            });
            if (newValue.length === 0) {
                this.handleReset();
            }
        } else if (filterName === "exam") {
            this.setState({
                examSelectedvalue: selectedValues,
            });
        } else if (filterName === "class") {
            this.setState({
                classSelectedvalue: selectedValues,
            });
        }
    };

    applyCallback = (startDate, endDate) => {
        const start = startDate.clone().startOf('day').unix();
        const end = endDate.clone().endOf('day').unix();
        console.log(start, end, "start end")
        this.setState({
            startDateCalender: start,
            endDateCalender: end,
        }

            // , () => {
            //     this.getStudentExamReportChange(
            //         this.state.selectedExamValue?.value,
            //         start,
            //         end
            //     );
            // }
        );
    };
    render() {

        console.log(this.props, "getDashBoardExams")
        if (!Cookies.get("token")) {
            this.props.history.push("/login");
            return null;
        }


        const { globals, getCountsForCollegeOverallExams, getStateWiseExamStatsCollegeOverall, getDistrictWiseExamStats } = this.props;
        const isInitialLoading = globals.loading ||
            (getCountsForCollegeOverallExams && getCountsForCollegeOverallExams.loading) ||

            (getStateWiseExamStatsCollegeOverall && getStateWiseExamStatsCollegeOverall.loading);
        const data = this.props.getStateWiseExamStatsCollegeOverall?.getCollegeOverallExams || [];

        const level = data?.[0]?.level || "state";

        if (isInitialLoading || this.state.isDistrictLoading || this.state.isCityLoading || this.state.isBranchLoading || this.state.isSectionLoading || this.state.isStateLoading) {
            return <PreloaderTwo />;
        }


        console.log(this.state.examTypeOptions, "sdljvnsj",)
        if (globals.error) {
            alert("Server Error. " + globals.error.message);
            return null;
        }

        let globalsData = { ...globals.globals };

        if (
            Cookies.get("userlevel") !== "1" &&
            Cookies.get("userlevel") !== "2"
        ) {
            globalsData.globalBranches = globalsData.globalBranches.filter(
                (item) => item.id === parseInt(Cookies.get("branch_id"))
            );
        }

        const counts = this.props.getCountsForCollegeOverallExams?.getCountsForCollegeOverallExams || [];






        const filterConfig = buildFilterConfig(this.props.globals, this.state);

        // Dynamic Filter Visibility Logic - Keep only level, exam, and class
        const dynamicFilterConfig = filterConfig.filter(f => ["level", "exam", "class"].includes(f.name));

        return (

            <div className={this.state.toggled}>

                <div
                    className="content-wrapper mb-2"
                    style={{ minHeight: "50vh" }}
                >
                    {/* <div className="d-flex justify-content-end col-12">
                        <Col sm={12} className="text-right mb-0 mt-0">
                            <Button onClick={() => this.setState({ showFilter: !this.state.showFilter })}
                                className="btn-sm border-0 bg-transparent"><i className="fa fa-filter" style={{ color: this.state.showFilter ? "#007bff" : "#6c757d" }}></i></Button>
                        </Col>
                    </div> */}
                    <Container fluid className="pt-4">

                        <div className="d-flex justify-content-end  mr-5 pr-4">
                            <Form.Group className="customDate mb-0 " controlId="StartDate" style={{ width: "150px" }}>
                                <DateBlock
                                    applyCallback={this.applyCallback}
                                    start={moment.unix(this.state.startDateCalender)}
                                    end={moment.unix(this.state.endDateCalender)}
                                />
                            </Form.Group>
                        </div>
                        <Card as={Card.Body} className='block_white mb-4 shadow-sm border-0'>
                            <Row className="align-items-end">
                                <Col md={3} sm={12} className="mb-3">
                                    <div className="form-group mb-0">
                                        <label className="font-weight-bold small text-uppercase text-muted mb-2 d-block">Select Level</label>
                                        <Select
                                            options={this.state.getLevelArr}
                                            value={this.state.levelSelectedValue[0]}
                                            onChange={(val) => this.handleMultipleSelectInputChange([val], "level")}
                                            placeholder="Select Level"
                                            isSearchable={false}
                                        />
                                    </div>
                                </Col>
                                <Col md={3} sm={12} className="mb-3">
                                    <div className="form-group mb-0">
                                        <label className="font-weight-bold small text-uppercase text-muted mb-2 d-block">Select Exam</label>
                                        <Select
                                            options={this.state.getExamArr}
                                            value={this.state.examSelectedvalue ? this.state.examSelectedvalue[0] : null}
                                            onChange={(val) => this.handleMultipleSelectInputChange([val], "exam")}
                                            labelledBy="Exams"
                                            overrideStrings={{ selectSomeItems: "Select Exams" }}
                                        />
                                    </div>
                                </Col>
                                <Col md={3} sm={12} className="mb-3">
                                    <div className="form-group mb-0">
                                        <label className="font-weight-bold small text-uppercase text-muted mb-2 d-block">Select Class</label>
                                        <MultiSelect
                                            options={this.state.getClassArr}
                                            value={this.state.classSelectedvalue}
                                            onChange={(val) => this.handleMultipleSelectInputChange(val, "class")}
                                            labelledBy="Classes"
                                            overrideStrings={{ selectSomeItems: "Select Class" }}
                                        />
                                    </div>
                                </Col>
                                <Col md={3} sm={12} className="mb-3 d-flex align-items-end">
                                    <Button
                                        variant="primary"
                                        onClick={this.handleFilter}
                                        className="flex-grow-1 mr-2 px-3 shadow-sm font-weight-bold"
                                        style={{ height: '38px' }}
                                    >
                                        Get Results
                                    </Button>
                                    <Button
                                        variant="outline-secondary"
                                        onClick={this.handleReset}
                                        className="shadow-sm"
                                        style={{ height: '38px' }}
                                    >
                                        Reset <i className="fa fa-refresh"></i>
                                    </Button>
                                </Col>
                            </Row>
                        </Card>
                        {counts ? (
                            <Row className="mb-4 mt-2">
                                <Col xl={2} lg={4} md={6} className="mb-3 px-2">
                                    <div className="p-4 border-0 rounded  text-center shadow-sm h-100" style={{ backgroundColor: "#f0f9ff" }}>
                                        <h3 className="font-weight-bold mb-2 text-primary">{counts.totalExams || 0}</h3>
                                        <span className="text-muted small font-weight-bold text-uppercase tracking-wider">Total Exams</span>
                                    </div>
                                </Col>
                                <Col xl={2} lg={4} md={6} className="mb-3 px-2">
                                    <div className="p-4 border-0 rounded  text-center shadow-sm h-100" style={{ backgroundColor: "#f0f9ff" }} >
                                        <h3 className="font-weight-bold mb-2 text-success">{counts.avgScore ? counts.avgScore.toFixed(2) : 0}</h3>
                                        <span className="text-muted small font-weight-bold text-uppercase tracking-wider">Avg Score</span>
                                    </div>
                                </Col>
                                {/* <Col xl={3} lg={4} md={6} className="mb-3 px-2">
                                    <div className="p-4 border-0 rounded  text-center shadow-sm h-100" style={{ backgroundColor: "#f0f9ff" }}>
                                        <h3 className="font-weight-bold mb-2 text-info">{counts.avgAccuracy ? counts.avgAccuracy.toFixed(2) : 0}%</h3>
                                        <span className="text-muted small font-weight-bold text-uppercase tracking-wider">Avg Accuracy</span>
                                    </div>
                                </Col> */}
                                <Col xl={2} lg={4} md={6} className="mb-3 px-2">
                                    <div className="p-4 border-0 rounded  text-center shadow-sm h-100" style={{ backgroundColor: "#f0f9ff" }}>
                                        <h3 className="font-weight-bold mb-2 text-warning">{counts.bestScore || 0}</h3>
                                        <span className="text-muted small font-weight-bold text-uppercase tracking-wider">Best Score</span>
                                    </div>
                                </Col>
                                <Col xl={3} lg={4} md={6} className="mb-3 px-2">
                                    <div className="p-4 border-0 rounded  text-center shadow-sm h-100" style={{ backgroundColor: "#f0f9ff" }}>
                                        <h3 className="font-weight-bold mb-2 text-info">{counts.totalStudents || 0}</h3>
                                        <span className="text-muted small font-weight-bold text-uppercase tracking-wider">Total Students</span>
                                    </div>
                                </Col>
                            </Row>
                        ) : (
                            <div className="text-center py-5">
                                <p className="text-muted">No report data available for this institution.</p>
                            </div>
                        )}
                        {/* {getTopStudents?.getTopStudents
                            && getTopStudents?.getTopStudents
                                .length > 0 && <TopStudentsChart data={getTopStudents?.getTopStudents.slice(0, 10)
                                } />} */}
                        <Row className="mt-4">
                            <Col xl={12} lg={12} md={12} sm={12}>
                                {this.state.renderedLevel === 5 ? (
                                    <CardLessDataTableWithSearch
                                        parentData={this.state.sectionWiseExamStats || []}
                                        particlecolumns={sectionWiseExamColumns(this.handleExamClick)}
                                        name="Section Wise Exam Report"
                                        tableHeading={this.state.tableHeaderData}
                                        defaultSorted={this.defaultSorted}
                                    />
                                ) : this.state.renderedLevel === 4 ? (
                                    <CardLessDataTableWithSearch
                                        parentData={this.state.branchWiseExamStats || []}
                                        particlecolumns={branchWiseExamColumns(this.handleExamClick)}
                                        name="Branch Wise Exam Report"
                                        tableHeading={this.state.tableHeaderData}
                                        defaultSorted={this.defaultSorted}
                                    />
                                ) : this.state.renderedLevel === 3 ? (
                                    <CardLessDataTableWithSearch
                                        parentData={this.state.cityWiseExamStats || []}
                                        particlecolumns={cityWiseExamColumns(this.handleExamClick)}
                                        name="City Wise Exam Report"
                                        tableHeading={this.state.tableHeaderData}
                                        defaultSorted={this.defaultSorted}
                                    />
                                ) : this.state.renderedLevel === 2 ? (
                                    <CardLessDataTableWithSearch
                                        parentData={this.state.districtWiseExamStats || []}
                                        particlecolumns={districtWiseExamColumns(this.handleExamClick)}
                                        name="District Wise Exam Report"
                                        tableHeading={this.state.tableHeaderData}
                                        defaultSorted={this.defaultSorted}
                                    />
                                ) : (
                                    <CardLessDataTableWithSearch
                                        parentData={this.state.stateWiseResultReceived ? this.state.stateWiseExamStats : (getStateWiseExamStatsCollegeOverall?.getStateWiseExamStatsCollegeOverall || [])}
                                        particlecolumns={stateWiseExamColumns(this.handleExamClick)}
                                        name="State Wise Exam Report"
                                        tableHeading={this.state.tableHeaderData}
                                        defaultSorted={this.defaultSorted}
                                    />
                                )}
                            </Col>
                        </Row>
                        {this.state.showReportSection && (
                            <Row ref={this.reportRef} style={{ minHeight: "100vh" }}>
                                <Col xs={12} sm={12} md={12} lg={12} xl={12} >
                                    <ExamReportForOverall
                                        key={this.state.exam_id}
                                        globals={this.props.globals.globals}
                                        stateData={{ eexamptype: 1 }}
                                        getDashBoardExams={this.props.getDashBoardExams?.getDashBoardExams}
                                        exam_id={this.state.exam_id}
                                        exam_name={this.state.exam_name}
                                        exam_type={this.state.exam_type}
                                        exam_typeValue={this.state.exam_typeValue}
                                        examsglobals={this.state.examsglobals}

                                    />

                                </Col>
                            </Row>
                        )}

                        <BatchReportsCollege
                            institution_id={parseInt(Cookies.get("institutionid"))}
                            exam_type={this.state.examSelectedvalue && this.state.examSelectedvalue.length > 0 ? parseInt(this.state.examSelectedvalue[0].value) : null}
                            from_date={this.state.startDateCalender}
                            to_date={this.state.endDateCalender}
                        />
                    </Container>
                </div>
            </div>
        );
    }
}

export default compose(
    withRouter,
    withApollo,

    graphql(FETCH_GLOBALS, {
        options: () => ({
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
            },
        }),
        name: "globals",
    }),

    graphql(FETCH_OVERALL_EXAMS_COUNTS, {
        options: (props) => ({
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
                exam_type: props.exam_type || 1,
                days: props.days || null,

                state_ids: props.globals.globals?.states?.map(s => Number(s.state_id)) || null,
                district_ids: props.district_ids?.length ? props.district_ids : null,
                city_ids: props.city_ids?.length ? props.city_ids : null,
                branch_ids: props.branch_ids?.length ? props.branch_ids : null,
                section_ids: props.section_ids?.length ? props.section_ids : null,
            },
            fetchPolicy: "network-only",
            notifyOnNetworkStatusChange: true,
        }),
        name: "getCountsForCollegeOverallExams",
    }),

    graphql(FETCH_STATE_WISE_DATA, {
        options: (props) => ({
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
                exam_type: props.exam_type || 1,
                from_date: props.from_date || null,
                to_date: props.to_date || null,

                state_ids: props.globals.globals?.states?.map(s => Number(s.state_id)) || null,
                class_ids: [],
            },
            fetchPolicy: "network-only",
            notifyOnNetworkStatusChange: true,
        }),
        name: "getStateWiseExamStatsCollegeOverall",
    }),

    // graphql(FETCH_TOP_STUDENTS, {
    //     options: (props) => ({
    //         variables: {
    //             institution_id: parseInt(Cookies.get("institutionid")),
    //             exam_type: props.exam_type || 2,
    //             days: props.days || null,
    //             state_id: props.state_id || null,
    //             district_id: props.district_id || null,
    //             city_id: props.city_id || null,
    //             branch_id: props.branch_id || null,
    //             section_id: props.section_id || null
    //         },
    //         fetchPolicy: "network-only",
    //         notifyOnNetworkStatusChange: true,
    //     }),
    //     name: "getTopStudents",
    // }),

    graphql(FETCH_EXAMS, {
        options: () => ({
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
            },
        }),
        name: "getDashBoardExams",
    }),



)(OverallReportsCollege);
